<template>
	<div class="w-full sm:w-1/2 sm:bg-gray-200 sm:shadow-md sm:rounded mx-auto p-8 sm:mt-24">
		<h3 class="text-center mb-6">Welcome Back!</h3>
		<!-- login block -->
		<form class="" @submit.prevent="login" v-if="activeBlock=='login'">
			<div class="mb-4">
				<label class="block text-sm mb-2" for="email">
					Email
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.email}" id="email" type="email" placeholder="Email" v-model="email">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.email">{{errors.email[Object.keys(errors.email)[0]]}}</p>
			</div>
			<div class="mb-6">
				<label class="block text-sm mb-2" for="password">
					Password
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.password}" id="password" type="password" placeholder="********" v-model="password">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.password">{{errors.password[Object.keys(errors.password)[0]]}}</p>
			</div>
			<div class="flex items-center justify-between">
				<action-button class="btn btn-blue" @button-clicked="login()">Sign In</action-button>
				<a class="inline-block align-baseline text-sm text-blue-500 hover:text-blue-800 cursor-pointer" href="#" @click="activeBlock='forgotpwd'">
					Forgot Password?
				</a>
			</div>
		</form>
	<!-- forgot password block -->
		<form class="" @submit.prevent="login" v-if="activeBlock=='forgotpwd'">
			<div class="mb-4">
				<label class="block text-sm mb-2" for="email">
					Email
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.email}" id="email" type="email" placeholder="Email" v-model="email">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.email">{{errors.email[Object.keys(errors.email)[0]]}}</p>
			</div>
			<div class="flex items-center justify-between">
				<action-button class="btn btn-blue" @button-clicked="forgotPassword()">Reset Password</action-button>
				<a class="inline-block align-baseline text-sm text-blue-500 hover:text-blue-800 cursor-pointer" href="#" @click="activeBlock='login'">
					Log In
				</a>
			</div>
		</form>
		<!-- reset pasword block -->
		<form class="" @submit.prevent="resetPassword" v-if="activeBlock=='reset'">
			<div class="mb-4">
				<label class="block text-sm mb-2" for="token">
					Security Token
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.token}" id="token" type="text" placeholder="Security Token" v-model="token">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.token">{{errors.token[Object.keys(errors.token)[0]]}}</p>
			</div>
			<div class="mb-6">
				<label class="block text-sm mb-2" for="password">
					Password
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.password}" id="password" type="password" placeholder="********" v-model="password">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.password">{{errors.password[Object.keys(errors.password)[0]]}}</p>
			</div>
			<div class="mb-6">
				<label class="block text-sm mb-2" for="password">
					Confirm Password
				</label>
				<input class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.confirm_password}" id="confirm_password" type="password" placeholder="********" v-model="confirm_password">
				<p class="text-red-500 text-xs italic mt-3" v-if="errors.confirm_password">{{errors.confirm_password[Object.keys(errors.confirm_password)[0]]}}</p>
			</div>
			<div class="flex items-center justify-between">
				<action-button class="btn btn-blue" @click="resetPassword()">Reset</action-button>
				<a class="inline-block align-baseline text-sm text-blue-500 hover:text-blue-800" href="#" @click="activeBlock='login'">
					Log In
				</a>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	name: 'Login',

	data () {
		return {
			loading: false,
			activeBlock: 'login',
			msg:'',
			email: '',
			password: '',
			confirm_password:'',
			token: '',
			errors: {},
			default_url: ''
		}
	},
	methods: {
		login: function () {
			console.log('here')
			let email = this.email
			let password = this.password
			this.loading = true
			this.$store.dispatch('auth/login', { email, password })
				.then(() => {
					this.default_url = this.$route.query.returnUrl ? this.$route.query.returnUrl : '/';
					// console.log("auth/role : "+this.$store.getters['auth/role'])
          			let region_id = this.$store.getters['auth/region_id']
					if(this.$store.getters['auth/role']=='Driver')
					{
						this.default_url = `/orders/${region_id}/pulled`
					}
					
					var next = this.default_url
					this.$router.push(next)
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		forgotPassword: function () {
			let email = this.email
			this.loading = true
			this.$http.post(`check`, {'email':email})
				.then(response => {
					this.msg = response.data.msg
					let success = {
						title: 'Password Reset Request Sent',
						message: 'Please check you email for password reset link',
						type: 'success'
					}
					this.$store.commit('setStatus', success);
					setTimeout(() => {
						this.$router.push('/login');
					}, 2000);
				})
				.catch(err => {
					this.errors = err
					let error = {
						title: 'Server responded with a ' + err.response.status,
						message: err.response.data.message,
						type: 'error'
					}
					store.commit('setStatus', error)
				})
				.finally(() => {
					this.loading = false
				})
		},
		resetPassword: function (){
			let token = this.token
			let password = this.password
			let confirm_password = this.confirm_password
			this.loading = true
			this.$http.post(`resetpwd`, {'token':token,'password':password,'password_confirmation':confirm_password})
				.then(response => {
					this.msg = response.data.msg
					let success = {
						title: 'Password Reset',
						type: 'success'
					}
					this.$store.commit('setStatus', success);
					this.$router.push('/login')
				})
				.catch(err => {
					this.errors = err
					let error = {
						title: 'Server responded with a ' + err.response.status,
						message: err.response.data.message,
						type: 'error'
					}
					store.commit('setStatus', error)
				})
				.finally(() => {
					this.loading = false
				})
		}
	},
	created () {
		if(this.$route.name == 'Login')
		{
			this.activeBlock = 'login';
		}
		else if(this.$route.name == 'Reset')
		{
			this.activeBlock = 'reset';
			this.token = this.$route.query.token ? this.$route.query.token : '';
		}
	}
}
</script>

<style lang="css" scoped>
</style>
